var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/editicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Edit",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8666667,0.883555287 C17.2934403,0.312679329 16.5158214,-0.00540815756 15.7068357,0 C14.8978501,0.00554734575 14.1246099,0.334135909 13.5591667,0.912721954 L1.47583333,12.9960553 L0,18.750222 L5.75416667,17.2743886 L17.8375,5.19105529 C18.416086,4.6256121 18.7446746,3.8523719 18.750222,3.04338623 C18.7556301,2.23440057 18.4375426,1.45678164 17.8666667,0.883555287 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2133333,
    y1: 1.25855529,
    x2: 17.4916667,
    y2: 5.53688862,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4683333,
    y1: 3.00355529,
    x2: 15.7466667,
    y2: 7.28188862,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.47583333,
    y1: 12.9960553,
    x2: 5.75833333,
    y2: 17.270222,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.2758ee84568c93b6e92a4347b7cc5abb.svg";
export { ForwardRef as ReactComponent };